import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getUnifiedInvoice = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.unified_invoice.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate) {
    const response = await axios(configws)
    data = { unified_invoice: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.unified_invoice.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(unifiedinvoice => {

      return (
        (
          String(unifiedinvoice.id_comission_master).toLowerCase().includes(queryLowered) ||
          unifiedinvoice.nombre.toLowerCase().includes(queryLowered) ||
          (unifiedinvoice.oficina && unifiedinvoice.oficina.toLowerCase().includes(queryLowered)) ||
          (unifiedinvoice.identificar !== null && unifiedinvoice.identificar.toLowerCase().includes(queryLowered)) ||
          unifiedinvoice.fecha_creacion.toLowerCase().includes(queryLowered) ||
          String(unifiedinvoice.royalti).toLowerCase().includes(queryLowered) ||
          String(unifiedinvoice.prof_serv_rent).toLowerCase().includes(queryLowered) || 
          String(unifiedinvoice.total).toLowerCase().includes(queryLowered)

        )
      )
  })

  return [
    200,
    {
      allData: data.unified_invoice,
      total: filteredData.length,
      unified_invoice: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return list of unified_invoice
// ------------------------------------------------

let dataUnifiedInvoice = JSON.parse(localStorage.getItem("dataUnifiedInvoice")) || { unified_invoice: [], startDate: '', endDate: ''}

mock.onGet('/apps/unifiedInvoice/list').reply(async config => {

  const user = getUserData()

  const body = {
    page:            1,
    page_size:       '',
    property_filter: '',
    client_filter:   '',
    date_from:       config.startDate,
    date_to:         config.endDate
  }

  const now = new Date()
  const diffInMinutes = (now - dataUnifiedInvoice.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataUnifiedInvoice = { unified_invoice: [], startDate: '', endDate: ''}
  }

  const result = await getUnifiedInvoice(dataUnifiedInvoice, 1, GetApiCOC('getListComissionUnfied'), user.token, body, config)

  dataUnifiedInvoice = { unified_invoice: result[1].allData, startDate: config.startDate, endDate: config.endDate }

  localStorage.setItem("dataUnifiedInvoice", JSON.stringify(dataUnifiedInvoice))

  return result
})

